import { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { OpportunityMedia } from "./OpportunityMedia";
import { OpportunityDetailedView } from "./OpportunityDetailedView";
import { OpportunityHeader } from "./opportunity-card/OpportunityHeader";
import { OpportunityDeadline } from "./opportunity-card/OpportunityDeadline";
import { OpportunityDetails } from "./opportunity-card/OpportunityDetails";

interface OpportunityCardProps {
  id: string;
  title: string;
  description: string;
  type: string;
  location: string | null;
  remoteAllowed: boolean;
  compensation: string | null;
  deadline: string | null;
  requirements: string | null;
  lookingFor?: string[] | null;
  createdBy: {
    id: string;
    fullName: string | null;
    avatarUrl: string | null;
  } | null;
}

export const OpportunityCard = ({
  id,
  title,
  description,
  type,
  location,
  remoteAllowed,
  compensation,
  deadline,
  requirements,
  lookingFor,
  createdBy,
}: OpportunityCardProps) => {
  const [isDetailedViewOpen, setIsDetailedViewOpen] = useState(false);

  return (
    <>
      <Card 
        className={`
          hover:shadow-lg transition-all duration-500 cursor-pointer 
          ${type === 'audition' ? 'border-l-4 border-l-purple-500' : ''}
          transform hover:-translate-y-1 hover:scale-[1.02]
          relative backdrop-blur-sm bg-background/80
          animate-fade-in
        `}
        style={{
          transformStyle: 'preserve-3d',
          perspective: '1000px',
        }}
        onClick={() => setIsDetailedViewOpen(true)}
      >
        <CardHeader>
          <div className="flex items-start justify-between">
            <OpportunityHeader 
              title={title}
              type={type}
              createdBy={createdBy}
            />
            <OpportunityDeadline deadline={deadline} />
          </div>
          {lookingFor && lookingFor.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-2">
              {lookingFor.map((role, index) => (
                <Badge key={index} variant="secondary" className="text-xs">
                  {role}
                </Badge>
              ))}
            </div>
          )}
        </CardHeader>
        <CardContent>
          <OpportunityMedia opportunityId={id} />
          <OpportunityDetails
            description={description}
            location={location}
            compensation={compensation}
            remoteAllowed={remoteAllowed}
            requirements={requirements}
            lookingFor={lookingFor}
          />
        </CardContent>
      </Card>

      {createdBy && (
        <OpportunityDetailedView
          isOpen={isDetailedViewOpen}
          onClose={() => setIsDetailedViewOpen(false)}
          opportunityId={id}
          createdBy={createdBy}
        />
      )}
    </>
  );
};